require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-basic-data-structures-add-items-to-an-array-with-push-and-unshift.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-basic-data-structures-add-items-to-an-array-with-push-and-unshift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-basic-data-structures-add-items-to-an-array-with-push-and-unshift!./.cache/json/javascript-algorithms-and-data-structures-basic-data-structures-add-items-to-an-array-with-push-and-unshift.json
// module id = 2231
// module chunks = 231608221292675